/**
 * The DOM lib types `matchMedia` as ever-present, but jsdom implements no media queries at all, so
 * the honest type admits absence. Every caller then handles "no media queries" explicitly instead of
 * optional-chaining a value the compiler believes cannot be missing.
 */
export const matchMediaOrNull: ((query: string) => MediaQueryList) | null =
  (globalThis as { matchMedia?: (query: string) => MediaQueryList }).matchMedia?.bind(globalThis) ??
  null;

/** Same honesty for Web Audio: jsdom has no `AudioContext`, so the type admits absence. */
export const audioContextOrNull: (new () => AudioContext) | null =
  (globalThis as { AudioContext?: new () => AudioContext }).AudioContext ?? null;
